import * as municipalityComponent from './components/municipality';
import * as fieldComponent from './components/field';
import * as accessNumberComponent from './components/access_number';
import * as searchComponent from './components/search';

// ページ読み込み時の処理
document.addEventListener('turbolinks:load', function() {
  // 開催地のアクション
  municipalityComponent.municipalityAllSelect();
  municipalityComponent.municipalityAllRelease();
  municipalityComponent.municipalityCustom();
  // 分野のアクション
  fieldComponent.fieldAllSelect();
  fieldComponent.fieldAllRelease();
  fieldComponent.fieldCustom();
  // アクセスの多いボランティア情報のアクション
  accessNumberComponent.prevAccessNumber();
  accessNumberComponent.currentAccessNumber();
  accessNumberComponent.nextAccessNumber();
  // 詳細検索のアクション
  searchComponent.submitAction();
  searchComponent.ajaxSearchGroupResult();
  searchComponent.stopPagenationSubmitAction();
})
